<template>
  <div class="p-6 w-full h-full flex flex-col bg-white rounded-2xl">
    <!-- title and search bar -->
    <div class="flex flex-row items-center justify-start space-x-2">
      <img class="w-14 h-14 rounded-full object-cover" :src="memberDetail.profile" alt="" />
      <p class="text-3xl text-blue">
        {{ memberDetail.first_name }} {{ memberDetail.last_name }} Subscription
        history
      </p>
    </div>
    <!-- body -->
    <div>
      <table class="table-auto w-full">
        <thead class="border-b-2 border-light-gray">
          <tr class="text-left text-gray text-lg">
            <th class="py-2 font-normal">Member Category</th>
            <th class="py-2 font-normal">Price</th>
            <th class="py-2 font-normal text-center">For Year</th>
            <th class="py-2 font-normal">Payment Method</th>
            <th class="py-2 font-normal">Payment Date</th>
            <th class="py-2 font-normal text-center">Status</th>
            <th class="py-2 font-normal text-center">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(paymentData, index) in memberPayment" :key="paymentData.id" class="text-lg">
            <td>{{ paymentData.subscription.name }}</td>
            <td>
              $ {{ parseFloat(paymentData.subscription.price).toFixed(2) }}
            </td>
            <td class="text-center">{{ paymentData.for_year }}</td>
            <td v-if="paymentData.payment">{{ paymentData.payment.bank_name }}</td>
            <td v-else></td>
            <td>
              {{ moment(paymentData.created_at).format("DD MMMM YYYY h:mm A") }}
            </td>
            <!-- payment status -->
            <td>
              <div class="flex justify-center my-2">
                <div class="flex justify-center">
                  <div v-if="paymentData.status == '-1'" class="px-4 py-1 bg-light-red text-red rounded-full w-max">
                    <p>Rejected</p>
                  </div>
                  <div v-if="paymentData.status == '0'" class="px-4 py-1 bg-light-gray text-gray rounded-full w-max">
                    <p>Pending</p>
                  </div>
                  <div v-if="paymentData.status == '1'" class="px-4 py-1 bg-light-blue text-blue rounded-full w-max">
                    <p>Accept</p>
                  </div>
                </div>
              </div>
            </td>
            <td>
              <div v-if="index == '0'" class="flex justify-center relative">
                <Menu>
                  <MenuButton>
                    <EllipsisVerticalIcon class="w-8 h-8 text-black hover:text-blue cursor-pointer" />
                  </MenuButton>
                  <MenuItems class="
                      p-1
                      space-y-1
                      absolute
                      top-8
                      right-8
                      z-50
                      bg-white
                      border border-light-gray
                      shadow-md
                      rounded-lg
                      w-max
                    ">
                    <MenuItem @click="handleUpdatePayStatus(paymentData.id, '1')" v-if="paymentData.status != '1'"
                      class="hover:bg-light-blue m-1 rounded-md cursor-pointer">
                    <div class="flex flex-row items-center px-4 py-2 min-w-min">
                      <ReceiptRefundIcon class="text-blue w-5 h-5 mr-4" />
                      <p class="text-blue">Confirm Payment</p>
                    </div>
                    </MenuItem>
                    <MenuItem @click="handleUpdatePayStatus(paymentData.id, '-1')" v-if="paymentData.status != '-1'"
                      class="hover:bg-light-blue m-1 rounded-md cursor-pointer">
                    <div class="flex flex-row items-center px-4 py-2 min-w-min">
                      <ReceiptRefundIcon class="text-blue w-5 h-5 mr-4" />
                      <p class="text-blue">Reject Payment</p>
                    </div>
                    </MenuItem>
                    <MenuItem @click="handleUpdatePayStatus(paymentData.id, '0')" v-if="paymentData.status != '0'"
                      class="hover:bg-light-blue m-1 rounded-md cursor-pointer">
                    <div class="flex flex-row items-center px-4 py-2 min-w-min">
                      <ReceiptRefundIcon class="text-blue w-5 h-5 mr-4" />
                      <p class="text-blue">Set to Pending</p>
                    </div>
                    </MenuItem>
                  </MenuItems>
                </Menu>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <!-- loading animation -->
      <div class="
          min-h-full
          flex flex-col
          space-y-4
          items-center
          justify-center
          mt-24
        " v-if="isLoading">
        <div class="animate-ping w-12 h-12 bg-light-gray rounded-full"></div>
        <p class="text-gray text-lg font-sans font-light">Loading data</p>
      </div>
      <!-- no data icon -->
      <div class="min-h-full flex items-center justify-center mt-24" v-if="!memberPayment.length && !isLoading">
        <div class="flex flex-col">
          <div class="flex justify-center">
            <InboxIcon class="text-gray w-12 h-12 md:w-24 md:h-24" />
          </div>
          <p class="text-gray text-2xl font-sans font-light">No data found!</p>
        </div>
      </div>
    </div>
    <div class="mt-auto flex justify-end">
      <BasePagination :pageCount="metaLink.last_page" @navigate-to-page="handlePagination($event)" />
    </div>
  </div>
</template>

<script>
import BasePagination from "../components/BasePagination.vue";
import moment from "moment";
import userService from "../Services/user.service";
import { Menu, MenuButton, MenuItems, MenuItem } from "@headlessui/vue";
import {
  InboxIcon,
  ReceiptRefundIcon,
  EllipsisVerticalIcon,
} from "@heroicons/vue/24/outline";
import { useToast } from "vue-toastification";
export default {
  name: "ViewMemberSubscription",
  components: {
    BasePagination,
    Menu,
    MenuButton,
    MenuItems,
    MenuItem,
    InboxIcon,
    ReceiptRefundIcon,
    EllipsisVerticalIcon,
  },
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      isLoading: true,
      memberDetail: [],
      memberPayment: [],
      metaLink: [],
    };
  },
  methods: {
    getMemberSubscription(memberId) {
      userService.getMemberSubscriptionData(memberId).then((response) => {
        this.memberPayment = response.data.data;
        this.metaLink = response.data.meta;
        this.isLoading = false;
      });
    },
    getMemberInfo(memberId) {
      userService.getMemberDetail(memberId).then((respones) => {
        this.memberDetail = respones.data.data;
      });
    },
    handleUpdatePayStatus(paymentId, statusCode) {
      this.$Progress.start();
      let formData = new FormData();
      formData.append("status", statusCode);

      userService
        .storeUpdatePayStatus(paymentId, formData)
        .then(() => {
          this.$Progress.finish();
          this.getMemberSubscription(this.$route.params.id);
          this.toast.success("Payment status update success.");
        })
        .catch(() => {
          this.$Progress.fail();
          this.toast.error("Something went wrong! Could not update status.");
        });
    },
  },
  created() {
    this.$Progress.start();
    this.moment = moment;
    this.getMemberSubscription(this.$route.params.id);
    this.getMemberInfo(this.$route.params.id);
  },
  mounted() {
    this.$Progress.finish();
  },
};
</script>

<style scoped>

</style>